import {BASE_URL} from "../../config/network";

const searchVehiclesAPI = async ({locationId}) => {

    const URL = `${BASE_URL}/public/p2p/vehicle/search?locationId=${locationId}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log("GET Search vehicles")

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        console.log("GET Search vehicles ERROR")
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {searchVehiclesAPI}